import { mount } from '../dom-lifecycle';

// Zabezpieczenie autouzupełniania telefonu. Przeglądarka często podpowiada numer z prefiksem
// kraju (+48, 0048, 48, wiodące 0...). Maska 000-000-000 (patrz attributes.js / IMask) wzięłaby
// wtedy PIERWSZE 9 cyfr — czyli z prefiksem — i numer byłby błędny. Bierzemy OSTATNIE 9 cyfr,
// dzięki czemu prefiks zostaje obcięty.
//
// Uwaga: obcinamy TYLKO gdy wiele cyfr pojawia się naraz (autouzupełnienie / wklejenie).
// Zwykłe pisanie (±1 cyfra) zostawiamy masce, żeby nie przesuwać numeru przy dopisywaniu.
mount('[data-phone-pl]', function () {
	const last9 = (raw) => (raw || '').replace(/\D/g, '').slice(-9);
	let prevLen = (this.value || '').replace(/\D/g, '').length;

	const apply9 = (digits) => {
		const wanted = last9(digits);
		if (this._imask) {
			this._imask.value = wanted; // ustawia model IMask + sformatowaną wartość w polu
		} else {
			this.value = wanted;
		}
		prevLen = wanted.length;
	};

	// Faza przechwytywania: uruchamiamy się PRZED handlerem IMask (bubble), więc widzimy pełną
	// wartość, zanim maska utnie ją do pierwszych 9 cyfr.
	this.addEventListener('input', (e) => {
		const digits = (this.value || '').replace(/\D/g, '');
		const bulk = Math.abs(digits.length - prevLen) > 1; // wiele cyfr naraz = autofill/wklejenie
		if (digits.length > 9 && bulk) {
			apply9(digits);
			e.stopImmediatePropagation(); // nie pozwól masce przetworzyć surowej wartości ponownie
			$(this).trigger('input'); // odśwież synchronizację maski i walidację
			return;
		}
		prevLen = Math.min(digits.length, 9);
	}, true);

	// Część przeglądarek autouzupełnia bez zdarzenia input — łapiemy też change.
	$(this).on('change', () => {
		const digits = (this.value || '').replace(/\D/g, '');
		if (digits.length > 9) {
			apply9(digits);
		}
	});
});
